'use client';

import { useCallback } from 'react';
import { MarketType } from '@drift-labs/sdk';
import { UIMarket } from '@drift/common';
import MarketCellV2 from 'src/components/Tables/cells/MarketCellV2';
import { useSwitchMarket } from 'src/hooks/driftActions/market/useSwitchMarket';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import { PageRoute } from 'src/constants/constants';
import { cm } from 'src/utils/classNames';

interface MarketCellProps {
	isIsolated: boolean;
	marketIndex: number;
	marketSymbol: string;
	direction: 'long' | 'short';
	hideLeverage?: boolean;
	hidePositionType?: boolean;
	className?: string;
}

export function MarketCell({
	marketIndex,
	marketSymbol,
	direction,
	hideLeverage,
	hidePositionType,
	isIsolated,
	className = 'w-auto whitespace-nowrap py-0',
}: MarketCellProps) {
	const uiMarket = UIMarket.createPerpMarket(marketIndex);

	const { switchMarket } = useSwitchMarket();
	const isOnTradePage = useDriftStore(
		(s) => s.currentPageRoute === PageRoute.trade
	);

	const handleClick = useCallback(
		(e: React.MouseEvent<HTMLDivElement>) => {
			e.stopPropagation();
			switchMarket({
				marketIndex,
				marketType: MarketType.PERP,
				goToTradePage: !isOnTradePage,
			});
		},
		[marketIndex, isOnTradePage, switchMarket]
	);

	return (
		<MarketCellV2
			marketSymbol={marketSymbol}
			className={cm(className, 'w-auto py-0 whitespace-nowrap')}
			onClick={handleClick}
			direction={direction}
			marketType={uiMarket.marketType}
			marketIndex={uiMarket.marketIndex}
			isIsolated={isIsolated}
			hideLeverage={hideLeverage}
			hidePositionType={hidePositionType}
		/>
	);
}
